var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRefresh(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 58.3 50.8",
    enableBackground: "new 0 0 58.3 50.8",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#3E3E3E",
    d: "M2.1,24.1l3.2-3.4l3.4-3.2c0.7-0.8,2.1-0.8,2.9,0l3.2,3.2l3.4,3.4 c0.8,0.7,0.6,1.4-0.7,1.4h-3.9c0,8.5,6.9,15.4,15.4,15.4c4.3,0,8.2-1.7,10.9-4.5l5.1,5.1c-4.1,4.1-9.8,6.6-16,6.6 C16.7,48.2,6.5,38,6.5,25.5H2.7C1.6,25.5,1.3,24.9,2.1,24.1L2.1,24.1z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#70CAF2",
    d: "M39.7,27.8c-0.8-0.8-0.6-1.5,0.6-1.5h4c0-8.5-6.9-15.4-15.5-15.4 c-4.2,0-8.1,1.7-10.8,4.5l-5.2-5.2c4.1-4.1,9.8-6.6,16.1-6.6c12.4,0,22.6,10.2,22.6,22.7h3.8c1.2,0,1.4,0.7,0.6,1.5l-3.3,3.3 l-3.3,3.3c-0.8,0.8-2.1,0.8-2.9,0L43,31.1L39.7,27.8z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefresh);
export default __webpack_public_path__ + "static/media/refresh.b4997052d810ec5f3e1f051c57c74df2.svg";
export { ForwardRef as ReactComponent };